<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$cloudDownload"
				start
			/>
			<translate>Download</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="auto">
					<v-btn
						color="primary"
						:href="`/api/v0/adyensettlementreportfiles/download?id=${id}`"
						elevation="0"
					>
						<translate>
							Download Settlement Report
						</translate>
					</v-btn>
				</v-col>
				<v-col cols="auto">
					<v-btn
						color="primary"
						elevation="0"
						@click="downloadLedger()"
					>
						<translate>
							Download Ledger CSV
						</translate>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>

import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {
	name: 'SettlementReportDownloadCard',
	props: {
		id: {
			type: String,
			required: true
		},
	},

	methods: {

		/**
		 * Download ledger
		 */
		downloadLedger () {
			axios.get(`/api/v0/adyensettlementreportfiles/export?id=${this.id}`)
				.then((response) => {
					const file = response.data;

					if (file !== undefined) {
						const filename = response.headers['content-disposition'].split('filename=')[1];

						this.downloadFile(file, filename);
					}
				})
				.catch((error) => {
					displayError(this.$gettext('Something has gone wrong during data retrieval'));
					window.captureException(error);
				});
		},

		/**
		 * Downloads the file blob
		 * Needs to create an actual DOM element in order to make it possible to download from the window
		 * This immediately removes it.
		 *
		 * @param {File} file
		 * @param {string} fileName
		 * @returns {void}
		 * @protected
		 */
		downloadFile (file, fileName) {
			const blob = new Blob([file, ], {
				type: 'text/csv',
			});

			const link = document.createElement('a');

			link.href = window.URL.createObjectURL(blob);
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
	}
};
</script>
